import React from 'react';
import { Typography as TypographyMat } from '@material-ui/core';
import { TypographyProps } from './typography.scheme';

const Typography: React.FunctionComponent<TypographyProps> = (props) => {
    return <TypographyMat {...props} />;
};

export default Typography;
